<template>
<div class="And">
  <el-link
      class="Onclick"
      type="primary"
      :underline="false"
      @click.stop="dialogFormVisible = true"
      size="small"
    >
      <!-- @click="dialogFormVisible = true" -->
      删除</el-link
    >
  <el-dialog title="确认删除这条成员信息吗？" :visible.sync="dialogFormVisible">
    <img class="OimG" src="../../../assets/img/icon.png" alt="" />
    <p>从成员列表中彻底删除这条成员信息。</p>
    <div slot="footer" class="dialog-footer">
      <el-button @click.stop="dialogFormVisible=false">取 消</el-button>
      <el-button type="primary" @click.stop="del(value)">确 定 </el-button>
    </div>
  </el-dialog>
</div>
</template>
<script>
import { EnterpriseBackground } from "../../../api/backstageManagement";
export default {
  props: ["value", "Visible"],
  data() {
    return {
      child: 1,
      dialogFormVisible:false
    };
  },
  methods: {
    // deletel() {
    //   this.$emit("dialogForm", false);
    // },
    //单删
    del(uid) {
      EnterpriseBackground.deletUser(uid).then((res) => {
        console.log(res.data, uid);
        if (res.data.status) {
          this.$emit("childByvalue", this.child);
          this.dialogFormVisible=false
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        }
      });
    },
  },
};
</script>
<style scoped>
.And{
  display: flex;
  margin: 0;
  justify-content: flex-start;
}
#dialog {
  width: 5%;
  height: 0%;
  white-space: nowrap;
  margin-top: 0rem;
  margin-left: 12px;
}
.Onclick{
  margin-left: 18px;
  /* margin-top:-3px; */
}
.ApoTitle {
  color: #666666;
  font-size: 16px;
  font-weight: 400;
}
.Chzhi {
  width: 60px;
  height: 32px;
  font-size: 14px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin: 0 !important; */
}
.and {
  width: 60px;
  height: 32px;
  font-size: 14px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  /* margin: 0 !important; */
}
a:hover{text-decoration:none}
</style>
